export default __webpack_public_path__ + "static/media/Path3432.36837790.svg";